import BaseObject from './base_object'

export default class Service extends BaseObject {}
